import { NotFound as NotFoundComponent } from '@/components/Elements/NotFound';
import { Head } from '@/components/Head';
import { PublicLayout } from '@/components/Layout';

export const NotFound = () => {
  return (
    <PublicLayout className="flex">
      <Head />
      <NotFoundComponent />
    </PublicLayout>
  );
};
